
























































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import Picker from '@/components/common/edit/Picker.vue';
import Bridge from '@/common/bridge';

import fetch from '@/common/api/fetch';
import getUrlParam from '@/common/utils/getUrlParam';
import CONFIG from '@/common/config';
import Tooltip from '@/components/common/index/Tooltip.vue';
import AdditionalDetail from './AdditionDetail.vue';
import Empty from '@/pages/showDetail/Empty.vue';
import CallPhone from '@/pages/showDetail/CallPhone.vue';
import CancelModal from '@/pages/showDetail/CancelModal.vue';
import Confirm from '@/pages/showDetail/Confirm.vue';
import ConfirmCommon from '@/pages/showDetail/ConfirmCommon.vue';
import ConfirmThree from '@/pages/showDetail/ConfirmThree.vue';
import CancelDetailModal from '@/pages/showDetail/CancelDetailModal.vue';
import FailTooltip from '@/pages/showDetail/FailTooltip.vue';
@Component({
  components: {
    'xm-picker': Picker,
    'xm-confirm': Confirm,
    'additional-detail': AdditionalDetail,
    'tool-tip': Tooltip,
    'call-phone': CallPhone,
    'cancel-modal': CancelModal,
    'cancel-detail-modal': CancelDetailModal,
    'empty-block': Empty,
    'xm-confirm-three': ConfirmThree,
    'confirm-common': ConfirmCommon,
    'fail-tip': FailTooltip
  }
})
export default class GroupList extends Vue {
  @Prop({ required: true }) dataList!: any;
  @Prop({ required: true }) showDetail!: any;
  @Prop({ required: true }) totalCount!: string;
  @Prop({ required: true }) content!: any;
  @Prop({ required: true }) channel!: string;
  @Prop({ required: true }) ErrorCodeEnum!: any;
  @Prop({ required: true }) showGuideTip!: boolean;

  loading: any;
  showPicker: boolean = false;
  chooseItem: any = {};
  showCancelModal: boolean = false;
  showDetailModal: boolean = false;
  showConfirm: boolean = false;
  showConfirmThree: boolean = false;
  showConfirmCommon: boolean = false;

  hasPaid: boolean = true;
  isLadder: boolean = this.showDetail.isLadder || false;
  sortType: boolean = true;
  XMCounter: boolean = false;
  tabValue: boolean = true;
  anonymity: boolean = false;
  onlySelf: boolean = false;
  detailItem: any = {};
  cancelList: any = [];
  timer: any = null;
  timerNum: number = 0;
  configOption: any = {
    title: '确认取消报名？',
    content: '取消后，该家长无法再次报名该活动',
    okText: '确定',
    cancleText: '取消',
    okColor: '#FF4F4F'
  };
  configThreeOption: any = {
    title: '重新发起退款？',
    content: '选择重新退款后，系统会重新发起小麦收银退款，也可选择私下处理，系统将为你生成收支。',
    oneText: '重新退款',
    twoText: '私下处理',
    threeText: '取消'
  };

  configCommonOption: any = {
    type: 'ONE',
    title: '重新发起退款？',
    content: '选择重新退款后，系统会重新发起小麦收银退款，也可选择私下处理，系统将为你生成收支。',
    oneText: '重新退款',
    twoText: '私下处理',
    threeText: '取消'
  };

  showForceConfirm: boolean = false;
  configForceOption: any = {};

  // 团购-异常情况弹窗
  showErrorConfirm: boolean = false;
  configErrorOption: any = {};

  // 取消报名失败弹窗
  showCancelConfirm: boolean = false;
  configCancelOption: any = {
    title: '取消报名失败',
    content: '',
    okText: '私下处理',
    cancleText: '取消',
    cancelColor: '#0076FF',
    okColor: '#0076FF'
  };

  pickerItem: Array<object> = [
    {
      text: '呼叫',
      color: '#333',
      handler: () => {
        this.handleHidePicker();
        this.handleClickPhone();
      }
    },
    {
      text: '取消报名',
      color: '#333',
      handler: () => {
        this.handleHidePicker();
        this.handleShowModal();
      }
    }
  ];

  get needPay() {
    return this.showDetail.needPay;
  }

  get groupList(): Array<Array<object>> {
    const dataSet: Array<Array<object>> = [];
    if (this.hasPaid) {
      this.dataList.map((record: any) => {
        const { groupDetailVOS } = record || {};
        const owner = groupDetailVOS ? groupDetailVOS[0] : {}; // 团长单独柃出来
        dataSet.push({
          ...owner,
          ...record
        });
      });
    } else {
      dataSet.push(...this.dataList);
    }
    return dataSet;
  }

  get courseType() {
    return this.content.courseType || 'ONE';
  }
  get payType() {
    return this.content.payType || '';
  }
  get courseGroupList() {
    return this.content.courseGroupList || [];
  }
  created() {
    this.checkUserPermission();
    let tabType = getUrlParam('tabType');
    if (tabType === 'cancel') {
      this.tabValue = false;
      this.getCancelSignIn();
    } else {
      this.tabValue = true;
    }
  }

  handleToWithdraw() {
    if (this.channel === 'XM_CASHIER') {
      // 新活动-跳转到小麦收银
      if (getUrlParam('instId') && getUrlParam('aid')) {
        const param = {
          instId: getUrlParam('instId'),
          adminId: getUrlParam('aid'),
          groupCode: 'CashWithdrawal'
        };
        fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
          if (res.result) {
            const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
            const hash: string = window.location.hash.split('?')[1];
            const tempStr: string = (CONFIG.hybirdUrl as any)[env] + '/finance/balance?' + hash;
            window.location.replace(tempStr);
          } else {
            Vue.$toast.error('无【小麦收银-提现记录-提现】权限，请联系管理员（主账号）');
          }
        });
      }
    } else {
      // 旧活动-跳转到小麦秀钱包
      const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
      const hash: string = window.location.hash.split('?')[1];
      const tempStr: string = (CONFIG.hybirdUrl as any)[env] + '/pay/wallet?' + hash;
      window.location.replace(tempStr);
    }
  }

  handleChangeTab(hasPaid: boolean = true) {
    this.hasPaid = hasPaid;
    this.sortType = true;
    // 1: 已支付 2: 未支付
    this.$emit('refresh', { hasApply: hasPaid, activityDetailSortType: 'SIGN_UP_DESC' });
  }
  handleChangeTabValue(tabValue: boolean = true) {
    this.tabValue = tabValue;
    if (tabValue === false) {
      this.getCancelSignIn();
    } else {
      this.handleChangeTab();
    }
  }
  // 报名取消记录列表
  getCancelSignIn() {
    const broadcastId = getUrlParam('broadcastId');
    const param = {
      activityId: broadcastId,
      pageNo: 0,
      pageSize: 0
    };
    fetch.Sales('public/businessShow/getCancelSignIn', param).then((res: any) => {
      const { records } = res.result || {};
      this.cancelList = records;
    });
  }
  handleShowPicker(item: any, current: number) {
    this.chooseItem = item;
    this.showPicker = true;
  }

  handleHidePicker() {
    this.showPicker = false;
  }

  // 打电话
  handleClickPhone(): void {
    Bridge.callHandler((Api: any) => {
      Api.callContact({ number: this.chooseItem.phone });
    });
  }

  handleShowModal() {
    this.showErrorConfirm = false;
    const param = {
      instId: getUrlParam('instId'),
      adminId: getUrlParam('aid'),
      groupCode: 'DealXmShow'
    };
    fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
      if (res.result) {
        if (this.needPay && !this.hasPaid) {
          this.showConfirm = !this.showConfirm;
        } else {
          this.showCancelModal = !this.showCancelModal;
        }
      } else {
        Vue.$toast.error('暂无【管理小麦秀】权限，请联系管理员（主账号）');
      }
    });
  }
  handleShowError(inner: any) {
    this.chooseItem = inner;
    this.configErrorOption = {
      title: '拼团失败自动退款未成功',
      content: inner.cancelError,
      okText: '重新取消报名',
      cancleText: '取消',
      cancelColor: '#0076FF',
      okColor: '#0076FF'
    };
    this.showErrorConfirm = true;
  }
  handleHideConfirm() {
    this.showPicker = false;
    this.showConfirm = false;
    this.showCancelModal = false;
    this.showForceConfirm = false;
    this.showConfirmThree = false;
    this.showErrorConfirm = false;
    this.showCancelConfirm = false;
    this.showConfirmCommon = false;
  }
  handleHideDetail() {
    this.showDetailModal = false;
    this.detailItem = {};
  }
  // 取消报名
  handleCancelItem(val: boolean, flag: boolean = true) {
    this.loading = window.weui.loading('正在处理中，请稍后~');
    const broadcastId = getUrlParam('broadcastId');
    const isLeader = this.chooseItem.groupRole === 1;
    this.anonymity = ((isLeader && val) || (!isLeader && !val)) && flag ? true : false;
    this.onlySelf = isLeader && !val && flag ? false : true;
    const param = {
      activityId: broadcastId,
      anonymity: ((isLeader && val) || (!isLeader && !val)) && flag ? true : false,
      onlySelf: isLeader && !val && flag ? false : true,
      userId: this.chooseItem.userId
    };
    fetch.Sales('public/businessShow/cancelSignIn', param).then((res: any) => {
      const { taskId = '' } = res.result || {};
      this.timer = setInterval(() => {
        this.getCancelSignInResult(taskId, val);
      }, 1000);
    });
  }
  getCancelSignInResult(id: any, val: any) {
    const isLeader = this.chooseItem.groupRole === 1;
    fetch.Sales('public/businessShow/getCancelSignInResult', { id }).then((res: any) => {
      if (JSON.stringify(res.result) === '{}') {
         if (this.timerNum > 1800) {
          // 超过30分钟结束轮询
          this.loading.hide();
          clearInterval(this.timer);
          Vue.$toast.info('仍在处理中，可稍后刷新查看处理结果');
        } else {
           this.timerNum = this.timerNum + 1;
        }
      } else {
        const { errorCode = '', errorMessage = '' } = res.result || {};
        clearInterval(this.timer);
        this.loading.hide();
        if (errorCode) {
          this.showCancelModal = false;
          if (isLeader && !val) {
            this.configCommonOption = {
              type: 'ONE',
              title: '取消报名失败',
              content: `<span>${this.ErrorCodeEnum[errorCode] ||
                '退款出现异常，无法直接退回至用户账户。'}<span style="color:#FF8534">如仍需取消报名，可尝试对单个成员进行取消报名</span></span>`,
              oneText: '我知道了'
            };
            this.handleHideConfirm();
            this.showConfirmCommon = true;
          } else {
            this.configCancelOption.content = `<span>${this.ErrorCodeEnum[errorCode] ||
              '退款出现异常，无法直接退回至用户账户。'}<span style="color:#FF8534">如仍需退款，请私下处理</span>，系统将为你生成收支。</span>`;
            this.showCancelConfirm = true;
          }
        } else if (errorMessage) {
          Vue.$toast.error(errorMessage);
        } else {
          Vue.$toast.success('取消报名成功，可前往“取消报名记录”中查看');
          this.handleHidePicker();
          this.handleHideConfirm();
          this.$emit('refresh', { hasApply: this.hasPaid });
        }
      }
    });
  }
  // 取消报名失败-私下处理
  forceCancelSignIn() {
    const broadcastId = getUrlParam('broadcastId');
    const aid = getUrlParam('aid');
    const param = {
      activityId: broadcastId,
      userId: this.chooseItem.userId,
      anonymity: this.anonymity,
      onlySelf: this.onlySelf
    };
    fetch.Sales('public/businessShow/forceCancelSignIn', param).then((res: any) => {
      if (res.success) {
        Vue.$toast.success('取消报名成功，可前往“取消报名记录”中查看');
        this.handleHidePicker();
        this.handleHideConfirm();
        this.$emit('refresh', { hasApply: this.hasPaid });
      }
    });
  }
  // 排序
  handleSortType() {
    this.sortType = !this.sortType;
    this.$emit('refresh', { hasApply: this.hasPaid, activityDetailSortType: this.sortType ? 'SIGN_UP_DESC' : 'SIGN_UP_ASC' });
  }

  checkUserPermission() {
    const param = {
      instId: getUrlParam('instId'),
      adminId: getUrlParam('aid'),
      groupCode: 'SeeColRecord'
    };
    fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
      this.XMCounter = res.result;
    });
  }
  gotoXMCounter(id: string) {
    if (!this.XMCounter) {
      return;
    }
    let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    window.location.href = `${(CONFIG.hybirdUrl as any)[env]}/bank/new/wallet/detail?id=${id}&token=${getUrlParam('token')}&instId=${getUrlParam(
      'instId'
    )}&aid=${getUrlParam('aid')}&uid=${getUrlParam('uid')}&v=${getUrlParam('v')}${getUrlParam('vn') ? `&vn=${getUrlParam('vn')}` : ''}`;
  }
  openDetailCancel(item: any) {
    if (!this.needPay) return;
    this.showDetailModal = true;
    this.detailItem = item;
  }
  handleShowForce() {
    this.showConfirmThree = false;
    this.configForceOption = {
      title: '确认您私下已将家长支付款项退给家长？',
      content: `确认后，系统将取消该家长的报名，且对该笔退款生成一条收支明细`,
      okText: '确认',
      cancleText: '取消',
      cancelColor: '#0076FF',
      okColor: '#0076FF'
    };
    this.showForceConfirm = true;
  }
  // 重新退款
  handleRefundItem(flag: boolean) {
    this.loading = window.weui.loading('正在处理中，请稍后~');
    const broadcastId = getUrlParam('broadcastId');
    const param = {
      activityId: broadcastId,
      force: flag, // flag：true 私下退款
      tradeId: this.chooseItem.tradeId||this.detailItem.tradeId
    };
    fetch.Sales('public/businessShow/refund', param).then((res: any) => {
      const { taskId = '' } = res.result || {};
      this.getRefundResult(taskId);
    }).catch(() => {
      this.loading.hide();
    });
  }
  getRefundResult(id: any) {
    fetch.Sales('public/businessShow/getRefundResult', { id }).then((res: any) => {
      if (JSON.stringify(res.result) === '{}') {
        setTimeout(() => {
          this.getRefundResult(id);
        }, 500);
      } else {
        const { errorCode = '', errorMessage = '' } = res.result || {};
        this.loading.hide();
        if (errorCode === '' && errorMessage === '') {
          Vue.$toast.success('操作成功');
          this.handleHideConfirm();
          this.handleHideDetail();
          this.getCancelSignIn();
        } else {
          this.configForceOption = {
            title: '重新退款失败',
            content: `<span>${this.ErrorCodeEnum[errorCode] ||
              '退款出现异常，无法直接退回至用户账户。'}<span style="color:#FF8534">如仍需退款，请私下处理</span>，系统将为你生成收支。</span>`,
            okText: '私下处理',
            cancleText: '取消',
            cancelColor: '#0076FF',
            okColor: '#0076FF'
          };
          this.showConfirmThree = false;
          this.showForceConfirm = true;
        }
      }
    }).catch(() => {
      this.loading.hide();
    });
  }
  // 退款详情页面上的重新退款
  handleShowDetailThreeModal() {
    const param = {
      instId: getUrlParam('instId'),
      adminId: getUrlParam('aid'),
      groupCode: 'DealXmShow'
    };
    fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
      if (res.result) {
        this.showConfirmThree = true;
      } else {
        Vue.$toast.error('暂无【管理小麦秀】权限，请联系管理员（主账号）');
      }
    });
  }
  handleShowThreeModal(e: any, item: any) {
    e.stopPropagation();
    e.preventDefault();
    const param = {
      instId: getUrlParam('instId'),
      adminId: getUrlParam('aid'),
      groupCode: 'DealXmShow'
    };
    fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
      if (res.result) {
        this.chooseItem = item;
        this.showConfirmThree = true;
      } else {
        Vue.$toast.error('暂无【管理小麦秀】权限，请联系管理员（主账号）');
      }
    });
  }
}
